import { createUseStyles } from 'react-jss';
import { PricingAppTheme } from '~app/styles/theme';
import { HIGHLIGHT } from '~pricing/components/Summary/useStyles';

import { MD_MEDIA_QUERY } from '~shared/media-query';

type Props = {
  packageName: string;
};
type Rules = 'Highlighted' | 'Package';

export default createUseStyles<Rules, Props, PricingAppTheme>(
  ({ spacing, type, pricingPalette, packageTheme }: PricingAppTheme) => ({
    Highlighted: {
      ...HIGHLIGHT(pricingPalette.colors.flint, packageTheme),
      borderWidth: '3px !important',
    },
    Package: {
      position: 'relative',
      border: `1px solid ${pricingPalette.colors.pebble}`,
      [MD_MEDIA_QUERY]: {
        '&:not(:last-of-type):not($Highlighted)': {
          borderRight: 'none',
        },
      },
      '& aside': {
        top: 0,
        right: 0,
        width: '100%',
        '&:before, &:after': {
          display: 'none',
        },
        '& p': {
          transform: 'none',
          top: 0,
          left: 0,
          width: '100%',
          fontSize: 13,
        },
      },
      '& header': {
        paddingTop: spacing[6],
        '& h2': {
          fontSize: type.fontSize.body,
        },
        '& h3': {
          fontSize: 26,
          '& span': {
            fontWeight: 300,
            fontSize: type.fontSize.body,
          },
        },
        '& p': {
          fontSize: 11,
        },
        '& a': {
          fontSize: 13,
          borderRadius: 0,
          height: 'auto',
          padding: 5,
          maxWidth: 140,
          width: '100%',
          marginBottom: 20,
        },
      },
    },
  })
);
